<div class="col-md-12">
  <div class="mb-3">
    <strong>Ultimate Remitter information</strong>
  </div>

  <np-remitter-details [remitterDetailsForm]="remitterDetails" [countries]="countries" [fullyStretchView]="false"></np-remitter-details>

  <div class="row mb-3 mt-3">
    <div class="col-md-6">
        <button class="btn btn-block btn-lg btn-greengo-o" (click)="cancel()">Cancel</button>
    </div>
    <div class="col-md-6">
        <button class="btn btn-block btn-lg" [ngClass]="{
                'btn-greengo': remitterDetails.valid,
                'btn-inactive': !remitterDetails.valid
            }" (click)="next()">
            Next
        </button>
    </div>
  </div>
</div>

